(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["activity-countdown-bar"] && !window.DesignMode) return;
  try {
    
  (function () {
    const header = document.querySelector('.shopify-section-header');
    const resizeObserver = new ResizeObserver(updateHeaderHeight);

    resizeObserver.observe(header);
    window.addEventListener('resize', updateHeaderHeight);

    function updateHeaderHeight() {
      const headerHeight = header.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-grid"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-grid-script')
    if (!window.featuredGrids && $url && $url.dataset.designMode !== 'yes') {
      window.featuredGrids = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredGrids
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["features-slideshow"] && !window.DesignMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-features-slideshow-script');
    if (!window.featuresSlideshow && $url) {
      window.featuresSlideshow = $url.value;
      var $script = document.createElement('script');
      $script.src = window.featuresSlideshow;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-overlay"] && !window.DesignMode) return;
  try {
    
  (function() {
    const linkBtnsFrame = document.querySelectorAll('.js-linkOpenFrame');
    for (let i = 0; i < linkBtnsFrame.length; i++) {
        linkBtnsFrame[i].addEventListener('click', function (e) {
            e.preventDefault();
            openWindow(this.href);
            return;
        });
    }
    
    function openWindow(url, options) {
        const width = 650;
        const height = 600;
        const left = (window.screen.width / 2) - (width / 2);
        const top = (window.screen.height / 2) - (height / 2);
        options = Object.assign({
            width: width,
            height: height,
            left: left,
            top: top,
            toolbar: 'no',
            menubar: 'no',
            status: 'no',
            resizable: 'no',
            location: 'no',
            scrollbars: 'no',
            titlebar: 'no'
        }, options);
        return window.open(url, 'popup', Object.keys(options).map(key => key + '=' + options[key]).join(','));
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v3"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milestone"] && !window.DesignMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-milestone-script')
  if (!window._milestone && $url && $url.dataset.designMode !== 'yes') {
    window._milestone = $url.value

    var $script = document.createElement('script')
    $script.src = window._milestone
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["primary-product-cards"] && !window.DesignMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-primary-product-cards-script');
    if (!window.primaryProductCards && $url) {
      window.primaryProductCards = $url.value;
      var $script = document.createElement('script');
      $script.src = window.primaryProductCards;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-highlight-slider"] && !window.DesignMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-product-highlight-slider-script')
    if (!window.productHighlightSlider && $url && $url.dataset.designMode !== 'yes') {
      window.productHighlightSlider = $url.value

      var $script = document.createElement('script')
      $script.src = window.productHighlightSlider
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secondary-product-cards"] && !window.DesignMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-secondary-product-cards-script');
    if (!window.secondaryProductCards && $url) {
      window.secondaryProductCards = $url.value;
      var $script = document.createElement('script');
      $script.src = window.secondaryProductCards;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
